import AboutInfo from "./about-info";
import "./about.css"
import ContactSection from "./contactsection";
import Footer from "./footer";
import Nav from "./navigation/nav";

function Contact(){
    return(
        <>
        <Nav></Nav>
        <ContactSection></ContactSection>
        <Footer></Footer>
        </>
    )
}
export default Contact;